import {
  MapPin,
  Plane,
  Train,
  Route,
  Clock,
  Car,
} from 'lucide-react';

const services = [
  {
    icon: MapPin,
    title: 'Local Taxi in Kannur',
    description: 'Quick and reliable local rides within Kannur city and nearby areas.',
  },
  {
    icon: Plane,
    title: 'Airport Pickup & Drop',
    description: 'Hassle-free transfers to/from Kannur, Calicut & Mangalore airports.',
  },
  {
    icon: Train,
    title: 'Railway Station Pickup',
    description: 'On-time pickups and drops to Kannur Railway Station.',
  },
  {
    icon: Route,
    title: 'Outstation Trips',
    description: 'Comfortable long-distance travel to any destination in Kerala.',
  },
  {
    icon: Clock,
    title: '24/7 Taxi Service',
    description: 'Available round the clock, even during late nights and early mornings.',
  },
  {
    icon: Car,
    title: 'Wedding & Event Cars',
    description: 'Premium vehicles for weddings, functions, and special occasions.',
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-8 bg-white">
      <div className="container px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block text-xs sm:text-sm font-bold text-primary uppercase tracking-widest mb-3 animate-fade-up">
            WHAT WE OFFER
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 animate-fade-up stagger-1">
            Our <span className="gradient-text-animated">Services</span>
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base sm:text-lg animate-fade-up stagger-2">
            Comprehensive taxi services for all your travel needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-100 shadow-lg shadow-black/30 hover:border-primary/50 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 animate-fade-up group card-shine"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center gap-4 mb-4">
                {/* Icon */}
                <div className="blue-icon-circle !w-12 !h-12 icon-hover group-hover:animate-glow-pulse shrink-0">
                  <service.icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" strokeWidth={2} />
                </div>

                {/* Content */}
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </h3>
              </div>

              <p className="text-gray-600 leading-relaxed text-sm sm:text-base pl-0 sm:pl-16">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
